<div class="At-Container At-ContainerStoryPage">
    <div class="overlay"></div>
    <a routerLink="/dashboard" class="At-BackBtnPage"><i class="icon-back-arrow"></i></a>
    <a routerLink="/dashboard" class="At-BackBtnCancel"><i class="icon-cancel"></i></a>
    <div class="At-StoryPage">
        <div class="At-StoryHeader">
            <div class="At-StoryProfileImg">
                <figure>
                    <img src="assets/images/profile/profile-small.png" class="img-fluid " alt="">
                </figure>
            </div>
            <div class="At-StoryTitle d-flex ">
                <div class="At-StoryLeft">
                    <h5>Anatoli</h5>
                    <h6>2m ago</h6>
                </div>
                <div class="At-StoryRight">
                    <i class="icon-more"></i>
                </div>
            </div>
        </div>
        <div class="At-StorySlider">
            <ngx-glide [autoplay]="isAutoplay ? autoplay : false" [arrowLeftLabel]="arrowLeftLabel" [arrowRightLabel]="arrowRightLabel">

                <div>
                    <figure>
                        <img src="assets/images/story.jpg" class="img-fluid" alt="">
                    </figure>
                </div>
                <div>
                    <figure>
                        <img src="assets/images/story.jpg" class="img-fluid" alt="">
                    </figure>
                </div>
                <div>
                    <figure>
                        <img src="assets/images/story.jpg" class="img-fluid" alt="">
                    </figure>
                </div>
              </ngx-glide>
            <div class="At-FormStorySlider">
                <div class="form-group mb-0 At-FormWithIcon">
                    <i class="icon-face-emoji iconTwo"></i>
                    <input class="form-control At-InputSearch" type="text" placeholder="Say something ...">
                </div>
                <button type="button" class="At-VoiceBtn"><i class="icon-share"></i></button>
            </div>
        </div>
    </div>
</div>
